var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87.568733,
    height: 77.476944,
    viewBox: "0 0 87.568733 77.476944",
    fill: "none",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 21.16881,0.37987074 c 0.7383,-0.46142 1.6635,-0.50538 2.4423,-0.116 L 47.35001,12.133371 66.15551,0.37987074 c 0.7705,-0.4815 1.7416,-0.50699 2.5362,-0.0666 0.7947,0.4405 1.2877,1.27749996 1.2877,2.18599996 V 44.986771 c 0,0.8617 -0.4439,1.6627 -1.1746,2.1194 l -19.9942,12.4963 c -0.7383,0.4615 -1.6635,0.5054 -2.4423,0.116 l -23.7389,-11.8694 -18.8055001,11.7534 c -0.7705,0.4815 -1.7416,0.507 -2.5362,0.0666 -0.79467006,-0.4404 -1.28771006498035,-1.2774 -1.28771006498035,-2.186 v -42.4875 c 0,-0.8617 0.44392000498035,-1.6626 1.17461006498035,-2.1193 z m 3.8238,43.06230026 19.9942,9.997 v -36.8989 L 24.99261,6.5431707 Z M 19.99411,7.0085707 4.9985099,16.380771 v 36.593 l 14.9956001,-9.3722 z m 29.9912,9.3722003 v 36.593 l 14.9956,-9.3722 V 7.0085707 Z",
    fill: "#00bbcc",
    id: "path1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 64.150649,51.356855 v 1.8013 h 1.8014 6.7552 c 0.2487,0 0.4503,0.2017 0.4503,0.4504 0,0.2487 -0.2016,0.4503 -0.4503,0.4503 h -6.7552 -1.8014 v 1.8014 6.7552 c 0,0.2487 -0.2016,0.4504 -0.4504,0.4504 -0.2487,0 -0.4503,-0.2017 -0.4503,-0.4504 v -6.7552 -1.8014 h -1.8014 -6.7552 c -0.2487,0 -0.4503,-0.2016 -0.4503,-0.4503 0,-0.2487 0.2016,-0.4504 0.4503,-0.4504 h 6.7552 1.8014 v -1.8013 -6.7552 c 0,-0.2488 0.2016,-0.4504 0.4503,-0.4504 0.2488,0 0.4504,0.2016 0.4504,0.4504 z m -0.4504,24.3187 c 12.1873,0 22.067098,-9.8797 22.067098,-22.067 0,-12.1873 -9.879798,-22.067 -22.067098,-22.067 -12.1872,0 -22.067,9.8797 -22.067,22.067 0,12.1873 9.8798,22.067 22.067,22.067 z",
    fill: "#00bbcc",
    stroke: "#ffffff",
    strokeWidth: 3.60278,
    id: "path1-8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPlan);
export default __webpack_public_path__ + "static/media/add-plan.a0412c4bfd0f6c0ab5afe79bf4a3d167.svg";
export { ForwardRef as ReactComponent };